import { all, call } from 'redux-saga/effects'
import authSagas from 'services/auth/sagas'
import vendorsSagas from 'services/vendors/sagas'
import invitationsSagas from 'services/invitations/sagas'
import homeSagas from '../services/home/sagas'
import snackbarSagas from '../services/snackbar/sagas'
import notificationsSagas from '../services/notifications/sagas'
import configSagas from '../services/config/sagas'
import errorSagas from '../services/errors/sagas'
import eventsSagas from '../services/events/sagas'
import searchesSagas from '../services/searches/sagas'
import procurementSagas from '../services/procurement/sagas'

import vendorDetailSagas from '../services/vendor-details/sagas'

function* allSagas() {
  try {
    yield all([
      authSagas(),
      vendorsSagas(),
      invitationsSagas(),
      homeSagas(),
      snackbarSagas(),
      notificationsSagas(),
      vendorDetailSagas(),
      configSagas(),
      errorSagas(),
      eventsSagas(),
      searchesSagas(),
      procurementSagas(),
    ])
  } catch (e) {
    console.error(e)
  }
}

export default function* rootSaga() {
  try {
    yield call(allSagas)
  } catch (e) {
    console.error(e)
  }
}
